import {useEffect, useState} from "react";
import {saveOrderIdToSessionStorage} from "../hooks/useOrderId";
import {SimpleLoader} from "./Helpers";

const enum SessionStatus {
    Loading,
    Error,
    Reauthorize,
    Ready
}

/**
 * A guard that checks if the Shopify session is valid, before starting the application.
 * @param children
 * @constructor
 */
export function ValidSessionGuard({children}: {children: React.ReactNode}) {
    const [sessionStatus, setSessionStatus] = useState(SessionStatus.Loading);
    useEffect(() => {
        // Hack: we'll lose the order id in the redirects chain during session refresh,
        // so we'll save it to session storage beforehand
        saveOrderIdToSessionStorage(new URLSearchParams(window.location.search));

        console.log("Validating session status...")
        // Call validation endpoint on the backend
        fetch("/api/validate-session")
            .then(res => {
                if (res.ok) {
                    console.log("Session is valid.");
                    setSessionStatus(SessionStatus.Ready);
                }
                // Under the hood Shopify App Bridge will redirect
                // to the auth page to refresh the session.
                // Our task is to display something in the meantime to make user wait
                else if (res.headers.get("X-Shopify-Api-Request-Failure-Reauthorize") === "1"){
                    console.log("Session is invalid. Reauthorizing...");
                    setSessionStatus(SessionStatus.Reauthorize);
                } else {
                    console.debug(res);
                    throw new Error("Unexpected response from server while validating session status.");
                }
            })
            .catch(err => {
              console.error(err);
              setSessionStatus(SessionStatus.Error);
            })
    }, []);

    switch (sessionStatus) {
        case SessionStatus.Loading:
        case SessionStatus.Reauthorize:
            return <SimpleLoader />;
        case SessionStatus.Error:
            return <div>An error occurred while validating the session.</div>;
        case SessionStatus.Ready:
            return children;
    }
}